import { render } from "./Wise.vue?vue&type=template&id=957988d6&lang=pug"
import script from "./Wise.vue?vue&type=script&lang=ts"
export * from "./Wise.vue?vue&type=script&lang=ts"

import "./Wise.vue?vue&type=style&index=0&id=957988d6&lang=scss"
script.render = render

export default script